import { FC, useState } from "react";
import { Link } from "react-router-dom";
import { InformationForOrderingOffices } from "./InformationForOrderingOffices";
import { TermsAndConditions } from "./TermsAndConditions";
import { LaborCategoryDescriptions } from "./LaborCategoryDescriptions";
import { LaborRates } from "./LaborRates";
import "../Contract.scss";

interface ICollapsables {
  information_for_ordering_offices: boolean;
  terms_and_conditions: boolean;
  labor_category_descriptions: boolean;
  labor_rates: boolean;
}

export const Contract_Schedule70: FC = () => {
  const [isCollapsed, setIsCollapsed] = useState<ICollapsables>({
    information_for_ordering_offices: true,
    terms_and_conditions: true,
    labor_category_descriptions: true,
    labor_rates: true,
  });
  return (
    <div className="Contract schedule70">
      <div className="Contract__wrapper">
        <Link className="back-to-contracts" to="/contract-vehicles">
          Back to Contracts
        </Link>
        <h1>GSA Schedule 70 - IT Services</h1>
        <div className="Contract__wrapper__section">
          <h2>General Contract Information</h2>
          <div className="Contract__wrapper__section__content">
            <span>Awarded: 11/10/2016</span>
            <span>Contract Number: GS-35F-068GA</span>
            <span>Term: Original 5 Years</span>
            <span>Good Through: 11/09/2021</span>
          </div>
        </div>
        <InformationForOrderingOffices
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
        <TermsAndConditions
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
        <LaborCategoryDescriptions
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
        <LaborRates isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      </div>
    </div>
  );
};
